import useSWR from 'swr';
import { get } from '@/utils/client';
import { BILLING_SUBSCRIPTION } from '@/routes/apiEndpoints';

//types
import type { SubscriptionType } from '@/types/pricingTypes/subscriptionType';
import type { AxiosError } from 'axios';
import type { SWRConfiguration, KeyedMutator } from 'swr';

//hooks
import useUser from '@/hooks/swr/useUser';

export type MutateSubscriptionType = KeyedMutator<SubscriptionType>;

const useSubscription = (options?: SWRConfiguration<SubscriptionType, AxiosError<Error>>) => {
    const { user } = useUser();
    const {
        data,
        mutate: mutateSubscription,
        error: subscriptionError,
        isLoading
    } = useSWR<SubscriptionType, AxiosError<Error>>(
        [BILLING_SUBSCRIPTION, user?.id],
        ([url]) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    return {
        subscription: data,
        isOnTrial: data?.product_key === 'trial',
        mutateSubscription,
        subscriptionError,
        isLoading
    };
};
export default useSubscription;
